import { api } from './client'
import type {
  AccessTokenResponse,
  ApiUser,
  ApiUserProfile,
  ChangePasswordRequest,
  MessageResponse,
  ResetPasswordRequest,
  SetPasswordRequest,
  SignInRequest,
  SignUpRequest,
  UpdateProfileRequest,
} from './types'

export const authApi = {
  signUp: (data: SignUpRequest, signupKey?: string) =>
    api.post<AccessTokenResponse>(
      signupKey ? `/auth/signup?key=${encodeURIComponent(signupKey)}` : '/auth/signup',
      data,
    ),

  signIn: (data: SignInRequest) =>
    api.post<AccessTokenResponse>('/auth/signin', data),

  requestPasswordReset: (email: string) =>
    api.post<MessageResponse>('/auth/request-password-reset', { email }),

  resetPassword: (data: ResetPasswordRequest) =>
    api.post<AccessTokenResponse>('/auth/reset-password', data),

  changePassword: (data: ChangePasswordRequest) =>
    api.post<MessageResponse>('/auth/change-password', data),

  // First-time password set for invitee-auto-created accounts. Requires the
  // bearer token returned from POST /v1/public/invites/:uuid (hasSetPassword=false).
  // 403s if the user already has a password set.
  setPassword: (data: SetPasswordRequest) =>
    api.post<AccessTokenResponse>('/auth/set-password', data),

  updateProfile: (data: UpdateProfileRequest) =>
    api.patch<ApiUser>('/auth/profile', data),

  // GET /auth/profile returns the authenticated user *with* their team
  // memberships eagerly populated — single round-trip replacement for
  // (decode JWT) + (GET /teams).
  getProfile: () => api.get<ApiUserProfile>('/auth/profile'),
}
